/* ADD GROUPS */
export const LIST_REPORT4 = "LIST_REPORT4"
export const LIST_REPORT4_SUCCESS = "LIST_REPORT4_SUCCESS"
export const LIST_REPORT4_CLEAN = "LIST_REPORT4_CLEAN"
export const LIST_REPORT4_ERROR = "LIST_REPORT4_ERROR"
